import React from 'react';
import { motion } from 'framer-motion';
interface IPhoneMockupProps {
  children: React.ReactNode;
  scale?: number;
  className?: string;
  priority?: boolean;
}
export function IPhoneMockup({
  children,
  scale = 1,
  className = '',
  priority = false
}: IPhoneMockupProps) {
  return <div className={`relative select-none ${className}`} style={{
    width: 393,
    height: 852,
    transform: `scale(${scale})`,
    transformOrigin: 'center center'
  }} data-id="element-159">
      {/* Outer Frame (Titanium) */}
      <div className="absolute inset-0 rounded-[55px] bg-gradient-to-br from-[#8B8680] via-[#A09A94] to-[#8B8680] shadow-2xl p-[3px]" data-id="element-160">
        {/* Inner Frame (Black Bezel) */}
        <div className="absolute inset-[3px] bg-black rounded-[52px] overflow-hidden" data-id="element-161">
          {/* Screen Content */}
          <div className="absolute inset-[8px] bg-black rounded-[44px] overflow-hidden" data-id="element-162">
            {children}
          </div>

          {/* Dynamic Island */}
          <div className="absolute top-[19px] left-1/2 -translate-x-1/2 w-[120px] h-[35px] bg-black rounded-full z-50 flex items-center justify-center" data-id="element-163">
            <div className="flex gap-3 items-center" data-id="element-164">
              {/* Camera lens reflection simulation */}
              <div className="w-3 h-3 rounded-full bg-[#1a1a1a] shadow-inner" data-id="element-165" />
              <div className="w-1.5 h-1.5 rounded-full bg-[#0d0d0d]" data-id="element-166" />
            </div>
          </div>

          {/* Status Bar Time (Left for RTL context, actually right in English but let's stick to standard iPhone layout) */}
          <div className="absolute top-[28px] left-[40px] z-40 text-white text-[15px] font-semibold tracking-wide" data-id="element-167">
            9:41
          </div>

          {/* Status Bar Icons (Right) */}
          <div className="absolute top-[28px] right-[35px] z-40 flex gap-1.5 items-center" data-id="element-168">
            <div className="w-4 h-4 text-white" data-id="element-169">
              <svg viewBox="0 0 24 24" fill="currentColor" data-id="element-170">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" data-id="element-171" />
              </svg>
            </div>
            <div className="w-4 h-4 text-white" data-id="element-172">
              <svg viewBox="0 0 24 24" fill="currentColor" data-id="element-173">
                <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z" data-id="element-174" />
              </svg>
            </div>
            <div className="w-6 h-3 border border-white/30 rounded-[4px] relative ml-1" data-id="element-175">
              <div className="absolute inset-0.5 bg-white rounded-[1px]" style={{
              width: '80%'
            }} data-id="element-176" />
            </div>
          </div>

          {/* Home Indicator */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-[130px] h-[5px] bg-black/20 backdrop-blur-md rounded-full z-50 mix-blend-difference opacity-50" data-id="element-177" />
        </div>
        {/* Side Buttons (Volume/Power) */}
        <div className="absolute top-[200px] -left-[2px] w-[2px] h-[30px] bg-[#8B8680] rounded-l-md" data-id="element-178" />{' '}
        {/* Mute */}
        <div className="absolute top-[250px] -left-[2px] w-[2px] h-[60px] bg-[#8B8680] rounded-l-md" data-id="element-179" />{' '}
        {/* Vol Up */}
        <div className="absolute top-[325px] -left-[2px] w-[2px] h-[60px] bg-[#8B8680] rounded-l-md" data-id="element-180" />{' '}
        {/* Vol Down */}
        <div className="absolute top-[280px] -right-[2px] w-[2px] h-[90px] bg-[#8B8680] rounded-r-md" data-id="element-181" />{' '}
        {/* Power */}
      </div>

      {/* Reflection Overlay */}
      <div className="absolute inset-0 rounded-[55px] bg-gradient-to-tr from-transparent via-white/10 to-transparent pointer-events-none z-50 opacity-40" data-id="element-182" />
    </div>;
}